import { Injectable, signal } from '@angular/core';

/**
 * Global "API is under maintenance" flag. Set by MaintenanceInterceptor when
 * the API answers with 503 or cannot be reached at all (status 0); read by AppComponent to render the maintenance
 * page over whatever route is active.
 *
 * The flag is sticky: it stays raised until the user reloads the widget. A
 * maintenance window is not momentary, and auto-clearing on the next 2xx
 * would make the page flicker during rolling deploys.
 */
@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private readonly underMaintenance = signal(false);

  readonly isUnderMaintenance = this.underMaintenance.asReadonly();

  enterMaintenance(): void {
    this.underMaintenance.set(true);
  }

  reset(): void {
    this.underMaintenance.set(false);
  }
}
